// ** Third Party Imports
import { ActionButton } from '@/shared/ui/elements/ActionButton'
import styled from 'styled-components'

export const LayoutWrapper = styled.div`
	height: 100%;
	display: flex;
	overflow: hidden;
	background-color: ${({ theme }) => theme.pallette.geniiWhite};
`

export const LayoutContentWrapper = styled.div<{ $fullViewport?: boolean }>`
	display: flex;
	flex-grow: 1;
	min-width: 0px;
	${({ $fullViewport }) =>
		$fullViewport
			? 'height: 100vh; overflow: hidden;'
			: 'min-height: 100vh;'}
	flex-direction: column;
	background-color: ${({ theme }) => theme.pallette.geniiWhite};
	position: relative;
`

export const LayoutPageContent = styled.main<{ $noPadding?: boolean }>`
	width: 100%;
	margin: 0 auto;
	padding: ${({ $noPadding }) => ($noPadding ? '0' : '2rem')};
	max-width: ${({ $noPadding }) => ($noPadding ? 'none' : '90rem')};
	height: 100%;
	overflow: ${({ $noPadding }) => ($noPadding ? 'hidden' : 'visible')};
`

export const ChatBotHeaderContainer = styled.div`
	position: relative;
	z-index: 100;
`


export const TransparentButton = styled(ActionButton)`
	position: absolute;
	top: 2rem;
	right: 2rem;
	border: none;
	box-shadow: none;
	&:hover {
		border: none;
		background: transparent;
		box-shadow: none;
		color: ${({ theme }) => theme.pallette.primary.main};
		& svg {
			path {
				stroke: ${({ theme }) => theme.pallette.primary.main};
			}
		}
		&:disabled {
			background: transparent;
		}
	}
`